/*
  Pure Tea 2026-10-21: Special Teas - Mengenanzeige "1 x Beutel" / "1 x Dose".
  Ergaenzt puretea_custom.js (Komponente <quantity-input>, Klasse QuantityInputDropdown2).
  - Produktseite + Warenkorb: Special Teas zeigen die gewaehlte Variante (Beutel/Dose) statt "Stueck".
  - Schnellansicht: erkennt Special Teas ueber den Produkt-Tag "Bio Tee/Special Edition".
    Vorher nur ueber die Body-Klasse "special-tea", die es dort nicht gibt -> Anzeige "x 100 g".
  - Produkte mit nur einer Variante (z. B. Fleur Musterbox) zeigen weiter "Stueck".
  Eingebunden in snippets/js-variables.liquid. Bei Theme-Updates mit uebernehmen.
*/
(function () {
  if (!window.customElements) return;

  var SPECIAL_TAG = 'Bio Tee/Special Edition';
  var specialByUrl = {};
  var labelByVariant = {};

  function cleanValues(values) {
    var out = [];
    values.forEach(function (v) {
      v = (v || '').trim();
      if (v && v !== 'Default Title') out.push(v);
    });
    return out.length ? out.join(' / ') : null;
  }

  function refreshAll() {
    document.querySelectorAll('quantity-input').forEach(function (q) {
      if (q.weightElement && typeof q.updateWeight === 'function') {
        try { q.updateWeight(); } catch (e) {}
      }
    });
  }

  function labelFromPicker(el) {
    var scope = el.closest('quick-view-modal') || el.closest('product-info') || document;
    var picker = scope.querySelector('variant-selects');
    if (!picker) return null;
    var values = [];
    picker.querySelectorAll('input[type="radio"]:checked, select').forEach(function (i) {
      values.push(i.value);
    });
    return cleanValues(values);
  }

  function labelFromCart(el) {
    var id = el.variantId ? String(el.variantId) : null;
    if (!id) return null;
    if (Object.prototype.hasOwnProperty.call(labelByVariant, id)) return labelByVariant[id];
    labelByVariant[id] = null;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        (cart.items || []).forEach(function (item) {
          labelByVariant[String(item.variant_id)] = cleanValues(
            (item.options_with_values || []).map(function (o) { return o.value; })
          );
        });
        refreshAll();
      })
      .catch(function () {});
    return null;
  }

  function patch() {
    var C = customElements.get('quantity-input');
    if (!C || !C.prototype.getVariantWeight || C.prototype.__ptSpecialLabel) return;
    var P = C.prototype;
    P.__ptSpecialLabel = true;

    var origIsSpecial = P.isSpecialTea;
    P.isSpecialTea = function () {
      if (!this.isCartDrawer) {
        var qv = this.closest('quick-view-modal');
        if (qv) {
          var host = this.closest('[data-url]') || qv.querySelector('[data-url]');
          var url = host && host.getAttribute('data-url');
          if (!url) return false;
          url = url.split('?')[0];
          var known = specialByUrl[url];
          if (known === true || known === false) return known;
          if (!known) {
            specialByUrl[url] = fetch(url + '.js')
              .then(function (r) { return r.json(); })
              .then(function (p) {
                specialByUrl[url] = (p.tags || []).indexOf(SPECIAL_TAG) !== -1;
                refreshAll();
              })
              .catch(function () { specialByUrl[url] = false; });
          }
          return false;
        }
      }
      return origIsSpecial.call(this);
    };

    var origWeight = P.getVariantWeight;
    P.getVariantWeight = function () {
      if (this.isSpecialTea()) {
        var label = this.isCartDrawer ? labelFromCart(this) : labelFromPicker(this);
        return label ? '× ' + label : 'Stück';
      }
      return origWeight.call(this);
    };

    refreshAll();
  }

  customElements.whenDefined('quantity-input').then(patch);

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) {
      setTimeout(refreshAll, 150);
      setTimeout(refreshAll, 600);
    }
  });
})();
